import React from 'react';
import PropTypes from 'prop-types';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-select/dist/react-select.css';
import RenderTemplates from './components/Templates';
import VideoPlayer from '../../components/VideoPlayer';
import AddToCart from './components/AddToCart';
import './TourPage.scss';

class TourPage extends React.Component {
  constructor(props) {
    super(props);
    this.showPlayer = this.showPlayer.bind(this);
    this.closePlayer = this.closePlayer.bind(this);
    this.state = {
      tourForCart: null,
      isShowAddToCartModal: false,
      videoPreview: null,
      isShowPlayer: false,
      isInCart: false,
      cartError: {},
    }
  }

  static propTypes = {
    match: PropTypes.object,
    categories: PropTypes.array,
    tour: PropTypes.object,
    getTourById: PropTypes.func,
    pageUnmounted: PropTypes.func,
    getTourPromise: PropTypes.object,
    history: PropTypes.object,
    addToCart: PropTypes.func,
    deleteFromCart: PropTypes.func,
    cartList: PropTypes.array,
    getCartTours: PropTypes.func,
    user: PropTypes.object,
    cities: PropTypes.array,
  };

  componentWillMount() {
    const {params} = this.props.match;
    if (params && params.id) {
      if (Object.keys(this.props.tour).length === 0)
        this.props.getTourById(+params.id)
    }
    this.setState({isInCart: this.isInCart(this.props.cartList, this.props.tour.id)})
  }

  componentWillReceiveProps(next) {
    this.setState({isInCart: this.isInCart(next.cartList, next.tour.id), cartError: next.cartError})
  }

  componentWillUnmount() {
    this.props.pageUnmounted()
  }

  isInCart(cartList, tourId) {
    if (cartList && cartList.length)
      for (let i = 0; i < cartList.length; i++) {
        if (+cartList[i].id === +tourId) {
          return true
        }
      }
    return false;
  }

  showPlayer(videoPreview) {
    this.setState({videoPreview, isShowPlayer: true});
  }

  closePlayer() {
    this.setState({videoPreview: null, isShowPlayer: false});
  }

  toggleShowAddToCartModal = () => {
    this.setState({isShowAddToCartModal: !this.state.isShowAddToCartModal})
  };

  showAddToCartModal = (id) => {
    let tourDataForModal = {};
    const cartTours = [];
    let differentCity = false;
    let selectedTourCityData = {};
    if (!this.state.cartError.wrongCity)
      this.props.getCartTours([id, ...this.props.cartList.map((item) => {
        return item.id
      })], (res) => {

        res.map((item) => {
          if (item.id === id) {
            tourDataForModal = item
          } else {
            cartTours.push(item)
          }
          return item
        });

        cartTours.map((item) => {
          if (item.cityId !== tourDataForModal.cityId) {
            differentCity = true
          }
          return item
        });

        this.props.cities.map((item) => {
          if (item.id === tourDataForModal.cityId) {
            selectedTourCityData = item;
          }
          return item;
        });

        if (differentCity) {
          this.setState({cartError: {wrongCity: true}});
          NotificationManager.error(
            `Please add tours from one city. ${selectedTourCityData.city}`,
            '', (5 * 1000));
          // console.log(tourDataForModal, cartTours, differentCity, selectedTourCityData);
        } else
          this.setState({tourForCart: tourDataForModal, isShowAddToCartModal: true})
      });
  };

  addToCart = (tour) => {
    this.setState({tourForCart: null, isShowAddToCartModal: false});
    this.props.addToCart(tour, this.props.tour.cityId)
  };

  render() {

    const {
      tour,
      categories,
      getTourPromise,
      history,
      deleteFromCart,
      user,
    } = this.props;

    const {
      videoPreview,
      isShowPlayer,
      isInCart,
      isShowAddToCartModal,
      tourForCart,
      cartError,
    } = this.state;

    if (getTourPromise.isRejected) {
      history.goBack();
    }
    return (
      <div className="tour-page tour-page__client-template">
        {
          videoPreview && isShowPlayer &&
          <VideoPlayer
            isOpen={isShowPlayer}
            close={this.closePlayer}
            video={videoPreview}
          />
        }

        <AddToCart
          isShow={isShowAddToCartModal}
          hideModal={this.toggleShowAddToCartModal}
          tourForCart={tourForCart}
          addToCart={this.addToCart}
        />

        <RenderTemplates
          tourTemplate={tour.tourTemplate}
          tmpProps={
            {
              ...tour,
              categories,
              showPlayer: this.showPlayer,
              addToCart: this.showAddToCartModal,
              deleteFromCart,
              isInCart,
              cartError,
              user
            }
          }
        />
        <NotificationContainer />
      </div>
    )
  }
}

export default TourPage;




// WEBPACK FOOTER //
// ./src/app/containers/TourPage/Component.js